
/*
 * @Description: 无token调取
 * @Author: 裴孚
 * @Date: 2023-03-21 15:08:01
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-27 09:55:31
 */
import $http from './index'
// 登录获取publickey
export const postAccessPublickey = (data) => $http({ url: '/api/v2/account/common/publickey', method: 'POST', data })
// 登录获取token
export const postAccessCode = (data) => $http({ url: '/api/v2/account/login', method: 'POST', data })
// 获取系统信息
export const postXiTongXinXi = (data) => $http({ url: '/api/v2/wangzhanlanmu/xitongxinxi/list', method: 'POST', data })
